<div class="app-titulo-pagina">
  <span>Novo Pagamento</span>
</div>

<div *ngIf="processando" class="text-center">
  <i class="fa fa-spinner fa-pulse fa-4x"></i>
</div>

<div class="container" *ngIf="!processando">
  <form (submit)="save()" class="col-xs-12 col-md-12" ngNativeValidate>
    <div class="app-panel">
      <div class="panel-body">
        <div class="well col-xs-12 col-md-8 col-md-offset-2 col-lg-8 col-lg-offset-2">
          <h4>Pagamento</h4>
          <label for="linhaDigitavel"><span id="tipo">
              {{ mainService.pagamentoService.pagamento.tipo === 'boleto' ? 'Boleto' : 'Conta de consumo'
              }}</span></label>
          <input type="text" id="linhaDigitavel" name="linhaDigitavel"
            [(ngModel)]="mainService.pagamentoService.pagamento.linhaDigitavel" class="form-control input-sm" uiTributo
            readonly>
          <br>
          <div *ngIf="mainService.pagamentoService.pagamento.tipo === 'boleto'">
            <label for="beneficiarioDocumento">Documento do beneficiário</label>

            <div class="input-group">
              <div class="input-group-btn">
                <button type="button" class="btn btn-sm"
                  [ngClass]="{'app-btn-best': documentoBeneficiarioTipo === 'CPF'}"
                  (click)="documentoBeneficiarioTipo = 'CPF'">
                  <i [ngClass]="{'fa fa-check': documentoBeneficiarioTipo === 'CPF'}"></i> CPF
                </button>

                <button type="button" class="btn btn-sm "
                  [ngClass]="{'app-btn-best': documentoBeneficiarioTipo === 'CNPJ'}"
                  (click)="documentoBeneficiarioTipo = 'CNPJ'">
                  <i [ngClass]="{'fa fa-check': documentoBeneficiarioTipo === 'CNPJ'}"></i> CNPJ
                </button>
              </div>

              <input type="text" id="beneficiarioDocumento" class="form-control input-sm"
                [(ngModel)]="mainService.pagamentoService.pagamento.beneficiarioDocumento" name="beneficiarioDocumento"
                *ngIf="documentoBeneficiarioTipo === 'CPF'" UiCpf required>

              <input type="text" id="beneficiarioDocumento" class="form-control input-sm"
                [(ngModel)]="mainService.pagamentoService.pagamento.beneficiarioDocumento" name="beneficiarioDocumento"
                *ngIf="documentoBeneficiarioTipo === 'CNPJ'" UiCnpj required>
            </div>

            <p class="help-block">Formato: {{ documentoBeneficiarioTipo === 'CPF' ? '00000000000' : '00000000000000' }}
            </p>
          </div>
        </div>
        <br>
        <div class="form-group col-xs-12 col-sm-6 col-md-6">
          <label for="data">Data de vencimento</label>
          <input type="text" id="data" class="form-control input-sm"
            [value]="mainService.pagamentoService.pagamento.vencimento | dateFormat:'':'dd/MM/yyyy'" readonly>
        </div>
        <div class="form-group col-xs-12 col-sm-6 col-md-6">
          <label for="valor-total-documento">Valor do documento(R$)</label>
          <input type="text" id="valor-total-documento" class="form-control input-sm"
            [value]="mainService.pagamentoService.pagamento.valorDocumentoMoeda" readonly>
        </div>
        <div class="form-group col-xs-12 col-sm-6 col-md-6"
          *ngIf="mainService.pagamentoService.pagamento.tipo === 'boleto'">
          <label for="valor-total-pagamento">Valor do pagamento(R$)</label>
          <input type="text" id="valor-total-pagamento" class="form-control input-sm" name="valor-total-pagamento"
            [(ngModel)]="mainService.pagamentoService.pagamento.valorMoeda" (ngModelChange)="calculaTotais()" uiMoeda
            [readonly]="!isValorDocumentoZero">
        </div>
        <div class="form-group col-xs-12 col-sm-6 col-md-6"
          *ngIf="mainService.pagamentoService.pagamento.tipo === 'boleto'">
          <label for="valor-total-desconto">Valor do desconto(R$)</label>
          <input type="text" id="valor-total-desconto" class="form-control input-sm" name="valor-total-desconto"
            [(ngModel)]="mainService.pagamentoService.pagamento.valorDescontoMoeda" (ngModelChange)="calculaTotais()"
            uiMoeda [readonly]="isValorDocumentoZero">
        </div>
        <div class="form-group col-xs-12 col-sm-4 col-md-4">
          <label for="valor-total-moeda">Total(R$)</label>
          <input type="text" id="valor-total-moeda" class="form-control input-sm text-left" [value]="totalMoeda"
            readonly>
        </div>
        <div class="form-group col-xs-12 col-sm-4 col-md-4">
          <label for="valor-total-pontos">Total em pontos</label>
          <input type="text" id="valor-total-pontos" class="form-control input-sm text-left"
            [value]="mainService.pagamentoService.pagamento.valorPontos | pontos" readonly>
        </div>
        <div class="form-group col-xs-12 col-sm-4 col-md-4">
          <label for="inputDescricao">Descrição </label>
          <input #inputObs type="text" class="form-control input-sm" name="inputDescricao" required autocomplete="off"
            id="inputDescricao" maxlength="30" (click)="clearTextoInicialDescricao()" [(ngModel)]="inputDescricao">
          <div *ngIf="!inputDescricao" class="text-danger" style="font-size: 10px;">
            Campo obrigatório
          </div>
        </div>
        <div class="form-group col-xs-12 col-sm-6 col-md-6 col-md-offset-3">
          <label for="ep">Senha eletrônica </label>
          <input type="password" id="ep" class="form-control input-sm" name="ep" [(ngModel)]="ep">
        </div>

        <div class="col-xs-12 text-center">
          <a (click)="router.navigate(['/pagamentos'])" class="btn btn-danger-v2 col-xs-12 col-md-2 col-md-offset-4">
            Voltar
          </a>
          <br class="visible-xs"><br class="visible-xs">
          <button type="submit" id="confirmar-pagamento" class="btn btn-success-v2 col-xs-12 col-md-2">
            Confirmar
          </button>
        </div>
      </div>
    </div>
  </form>
</div>


// WEBPACK FOOTER //
// ./src/app/pagamento/confirmacao-novo-pagamento/confirmacao-novo-pagamento.component.html